module.exports = __webpack_public_path__ + "static/media/Ashwin.ec495582.jpg";